<template>
  <v-list-item
    :key="item.id"
    @click="$emit('click', item)"
  >
    <v-list-item-action>
      <v-icon>{{ item.icon }}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>{{ item.text }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>

export default {
  props: {
    item: Object,
    index: Number,
  }
};
</script>